import React from "react";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";

import AddressFileds from "../AddressFileds";
import AddressType from "../AddressType";
import AdminOnly from "../../../AdminOnly";
import SuccessNotification from "../SuccessNotification";

const AddNewAddressTab = ({
  states,
  handleNewToggle,
  data,
  handleNewAddress,
  saveNewAddress,
  handleNewDiscard,
}) => {
  const { role } = useSelector((state) => state.login);

  return (
    <>
      {states?.successMsg && (
        <SuccessNotification successMsg={states.successMsg} />
      )}
      <div className="flex justify-content-between align-items-center mb-5 mt-4">
        <h4 className="address-heading m-0">Add New Address</h4>
        <AdminOnly>
          <div className="flex gap-2">
            <>
              <button className="discard-btn" onClick={handleNewDiscard}>
                Discard
              </button>
              <Button
                className={`save-btn ${states?.isEnableNewAddress && "disable"}`}
                loading={states?.isUpdateLoading}
                onClick={saveNewAddress}
                disabled={states?.isUpdateLoading || states?.isEnableNewAddress}
              >
                {!states?.isUpdateLoading && "Add Address"}
              </Button>
            </>
          </div>
        </AdminOnly>
      </div>
      <div className="grid w-full">
        <div className="col-12 text-left ">
          <p className="address-sub-heading">
            {" "}
            Select the address type you want to register
          </p>
        </div>
        <AddressType
          data={data}
          disabled={!["GXM_ADMIN"].includes(role)}
          disableTrade={states.isTradeAvailable}
          disablePhysical={states.isPhysicalAvailable}
          handleToggle={handleNewToggle}
        />
        {data.type && (
          <AddressFileds
            data={data}
            isEdit={["GXM_ADMIN"].includes(role)}
            handleOnchange={handleNewAddress}
          />
        )}
      </div>
    </>
  );
};

export default AddNewAddressTab;
